/**
 * @description Hook utilizado para manipular as divisões
 * @author Diego Sabino Amorim de Araújo
 * @file useDivisaoService.js
 * @license Copyright (c) 2022 SIGEP DIGETI ITEP/RN
 */

import { useDispatch } from 'react-redux'
import actionTypes from 'utils/actionTypes'
import { useFetch } from './useFetch'

export const useDivisaoService = () => {
  const fetch = useFetch()
  const dispatch = useDispatch()

  const listarDivisoesDeRegionalGlobal = async (idRegional, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`orgao/regionais/${idRegional}/divisoes/`)
      dispatch({
        type: actionTypes.FETCH_DIVISOES,
        divisoes: response.data.divisoesRegional,
      })
    } catch (err) {
      return
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarDivisaoAsync = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/orgao/regional/divisoes/${id}`)
      return response.data.divisao
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const listarDivisaoAnuncio = async (id, setProcessando) => {
    try {
      if (setProcessando) setProcessando(true)
      const response = await fetch.get(`/orgao/regional/divisoes/divisao/anuncio`)
      return response.data.divisoes
    } catch (err) {
      return null
    } finally {
      if (setProcessando) setProcessando(false)
    }
  }

  const cadastrarDivisao = async (dados, idRegional, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const novaDivisao = {
      nome: dados.nome,
      sigla: dados.sigla,
      descricao: dados.descricao,
      regional: idRegional,
    }
    await fetch.postOpen('/orgao/regional/divisoes/', novaDivisao)
    if (setProcessando) setProcessando(false)
  }

  const editarDivisao = async (id, dados, setProcessando) => {
    if (setProcessando) setProcessando(true)
    const divisao = {
      id: dados.id,
      nome: dados.nome,
      sigla: dados.sigla,
      descricao: dados.descricao,
      regional: dados.regional,
    }
    await fetch.putOpen(`/orgao/regional/divisoes/${id}/`, divisao)
    if (setProcessando) setProcessando(false)
  }

  const deletarDivisao = async (id, setProcessando) => {
    if (setProcessando) setProcessando(true)
    await fetch.del(`/orgao/regional/divisoes/${id}/`)
    if (setProcessando) setProcessando(false)
  }

  return {
    listarDivisoesDeRegionalGlobal,
    listarDivisaoAsync,
    deletarDivisao,
    cadastrarDivisao,
    editarDivisao,
    listarDivisaoAnuncio,
  }
}
